import {
  BusinessUserUpdateRequestType,
  BusinessUserUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useBusinessUserUpdate = (businessUserId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: BusinessUserUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `business-users/${businessUserId}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as BusinessUserUpdateResponseType,
      ),
    onSettled: (data) => {
      if (data) {
        queryClient.invalidateQueries({
          queryKey: [
            user?.uid,
            business?.id,
            ServerStateKeys.BusinessUser,
            data.id,
          ],
        });
        queryClient.invalidateQueries({
          queryKey: [user?.uid, business?.id, ServerStateKeys.BusinessUser],
        });
        queryClient.invalidateQueries({
          queryKey: [user?.uid, business?.id, ServerStateKeys.Businesses],
        });
        queryClient.invalidateQueries({
          queryKey: [ServerStateKeys.SellarUser],
        });
        queryClient.invalidateQueries({
          queryKey: [user?.uid, business?.id, ServerStateKeys.LegalEntity],
        });
      }
    },
  });
};
